import { SettingsState, SettingsAction, DEFAULT_SETTINGS } from '@/types/settings'

// RAW POWER REDUCER - MAXIMUM PERFORMANCE
export const settingsReducer = (state: SettingsState, action: SettingsAction): SettingsState => {
  switch (action.type) {
    case 'UPDATE_SETTING':
      return { ...state, [action.key]: action.value }
    case 'RESET_SECTION':
      const sectionDefaults = getSectionDefaults(action.section)
      return { ...state, ...sectionDefaults }
    case 'RESET_ALL':
      return { ...DEFAULT_SETTINGS }
    case 'LOAD_PRESET':
      return { ...state, ...action.preset }
    case 'EXPORT_SETTINGS':
      // Export to localStorage and clipboard
      const exportData = JSON.stringify(state, null, 2)
      localStorage.setItem('sws-settings', exportData)
      navigator.clipboard?.writeText(exportData)
      return state
    case 'IMPORT_SETTINGS':
      return { ...action.settings }
    default:
      return state
  }
}

// GET SECTION DEFAULTS - RAW POWER UTILITY
const getSectionDefaults = (section: string): Partial<SettingsState> => {
  switch (section) {
    case 'audio': return {
      sampleRate: 44100,
      bufferSize: 256,
      outputDevice: 'default',
      enableSpatialAudio: false,
      audioBitDepth: 16,
      audioChannels: 2
    }
    case 'visualization': return {
      theme: 'dark',
      colorScheme: 'ocean',
      particleCount: 1000,
      enableGlowEffects: true,
      frameRate: 60,
      enableParticles: true,
      enableShaders: true
    }
    case 'interface': return {
      language: 'en',
      layout: 'default',
      enableAnimations: true,
      highContrast: false,
      keyboardShortcuts: true,
      autoSave: true
    }
    case 'performance': return {
      quality: 'high',
      enableCaching: true,
      maxWorkers: 4,
      enableHardwareAccel: true,
      memoryLimit: 512,
      enableCompression: true
    }
    case 'advanced': return {
      enableDebug: false,
      logLevel: 'info',
      enableExperimental: false,
      developerMode: false,
      enableProfiling: false,
      enableTelemetry: false
    }
    default: return {}
  }
}